import React from "react";
import PropTypes from "prop-types";
import { useLocalization } from "@fluent/react";
import { ContentCard, Error } from "@narmi/design_system";
import OrganizationUser from "byzantine/src/OrganizationUser";

const ACCESS_LEVELS = {
  [OrganizationUser.ROLE.ADMIN]: {
    titleKey: "access-level-admin-title",
    descriptionKey: "access-level-admin-description",
    icon: "admin-user",
  },
  [OrganizationUser.ROLE.COLLABORATOR]: {
    titleKey: "access-level-collaborator-title",
    descriptionKey: "access-level-collaborator-description",
    icon: "users",
  },
  [OrganizationUser.ROLE.VIEWER]: {
    titleKey: "access-level-viewer-title",
    descriptionKey: "access-level-viewer-description",
    icon: "eye",
  },
};

const AccessLevelCard = ({ option, value, onChange }) => {
  const { l10n } = useLocalization();
  if (!ACCESS_LEVELS[option.title]) {
    return null;
  }
  const { titleKey, descriptionKey, icon } = ACCESS_LEVELS[option.title];
  const title = l10n.getString(titleKey, null, titleKey);
  const description = l10n.getString(descriptionKey, null, descriptionKey);
  const isSelected = value === option.value;
  return (
    <div
      data-testid={isSelected ? "selected" : "unselected"}
      className="nds-span-4 nds-span-tablet-6"
    >
      <ContentCard
        kind="toggle"
        onClick={(event) => {
          onChange({ ...event, target: { value: option.value } });
        }}
        isSelected={isSelected}
      >
        <h4 className="access-manager-radio-select-card--heading padding--bottom--s">
          {title}
          <span className={`narmi-icon-${icon}`}></span>
        </h4>
        <p>{description}</p>
      </ContentCard>
    </div>
  );
};

AccessLevelCard.propTypes = {
  option: PropTypes.object.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.any,
};

const RadioSelect = ({ onChange, value, error, options }) => (
  <>
    <div className="nds-grid">
      {options.map((option) => (
        <AccessLevelCard
          key={option.value}
          option={option}
          onChange={onChange}
          value={value}
        />
      ))}
    </div>
    <Error error={error} />
  </>
);

RadioSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array.isRequired,
  renderOption: PropTypes.func,
  error: PropTypes.string,
};

export default RadioSelect;
